import {GoogleCodeApiDto} from "./_RestModels";

export default class GoogleCode {
    constructor(public readonly code: string){}

    public static fromJson(json: GoogleCodeApiDto) {
        return new GoogleCode(json.credential);
    }
}